"use strict";
import ActivationLess from "./Activation.less";
export const ActivationContainer = {
    className: ActivationLess.container,
    template: "FieldSetTemplate"
};
export const ActivationItem = {
    className: ActivationLess.item,
    template: "FieldSetTemplate"
};
export const ActivationPartner = {
    className: ActivationLess.partner,
    template: "FieldSetTemplate"
};
export const ActivationNote = {
	className: ActivationLess.note,
	template: "FieldSetTemplate"
};

export default ({
    ActivationContainer,
    ActivationItem,
    ActivationPartner,
	ActivationNote
});


/** WEBPACK FOOTER **
 ** ./src/templates/ActivationBundle.js
 **/